<template>
  <div class="upload-wrapper">
    <el-upload
      :multiple="true"
      :class="is_btn ? 'upload-demo' : 'upload-demo1'"
      :headers="headers"
      :action="baseURL + up_load"
      :on-change="handleChange"
      :on-success="handleSuccess"
      :on-error="handleError"
      :before-upload="beforeUpload"
      :file-list="fileList"
      :limit="limit"
      :auto-upload="autoUpload"
      :show-file-list="false"
      :accept="accept"
    >
      <div v-if="is_btn" class="upload-container">
        <img style="width: 45px; height: 45px" src="@/assets/fiel_img.png" alt="上传" class="upload-icon" />
      </div>
      <el-button v-else size="mini" type="primary">点击此处上传</el-button>
    </el-upload>
  </div>
</template>

<script>
export default {
  name: 'MyUpload',
  props: {
    up_load: {
      type: String,
      default: '/api/common/upload'
    },
    limit: {
      type: Number,
      default: 5
    },
    autoUpload: {
      type: Boolean,
      default: true
    },
    accept: {
      type: String,
      default: '*/*'
    },
    is_btn: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      baseURL: process.env.NODE_ENV === 'production' ? 'https://dfh.beishancloud.com' : '',
      fileList: [],
      isUploaded: false,
      headers: {}
    }
  },
  computed: {
    isImage() {
      // return this.fileList.length > 0 && this.fileList[0].type.startsWith('image/');
      return ''
    }
  },
  mounted() {
    let token = localStorage.getItem('token')
    this.headers = {
      Authorization: token
    }
  },
  methods: {
    handle_close() {
      this.fileList = []
    },
    handleChange(file, fileList) {
      this.fileList = fileList
      this.$emit('change', file, fileList)
    },
    handleSuccess(response, file, fileList) {
      this.isUploaded = true
      this.fileList = fileList.map(file => ({
        ...file,
        url: URL.createObjectURL(file.raw) // 生成缩略图的 URL
      }))
      this.$emit('success', response, file, fileList)
    },
    handleError(err, file) {
      this.$emit('error', err, file)
    },
    beforeUpload(file) {
      console.log(file, '----->')
      const validTypes = [
        'image/jpeg',
        'image/png',
        'application/vnd.ms-excel', // .xls
        'application/pdf',
        'application/msword', // .doc 的正确 MIME 类型
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' // .xlsx
      ]

      const isValidType = validTypes.includes(file.type)
      const isValidSize = file.size / 1024 / 1024 < 30 // 30MB 限制

      if (!isValidType) {
        this.$message.error('上传文件只能是 JPG、PNG、PDF、XLS、DOC、DOCX 或 XLSX 格式!')
      } else if (!isValidSize) {
        this.$message.error('上传文件不能超过 30MB!')
      }

      return isValidType && isValidSize
    },
    handleRemove() {
      this.fileList = []
      this.isUploaded = false
    }
  }
}
</script>

<style scoped>
.upload-wrapper {
  /* display: flex;
    flex-direction: column;
    align-items: center; */
  margin-left: 20px;
}

.upload-demo {
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
}

.upload-demo1 {
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  cursor: pointer;
}

.upload-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.upload-icon {
  width: 30px;
  /* 根据需要调整图标大小 */
  height: 30px;
  /* 根据需要调整图标大小 */
}

.uploaded-file {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.thumbnail {
  width: 60px;
  height: 60px;
  object-fit: cover;
  margin-right: 10px;
}
</style>
